export function isTenancyEnabledForSecurityTokenInCookie(
  tenantID: string,
  securityTokenInCookieTenantOverrides: string[],
): boolean {
  return (securityTokenInCookieTenantOverrides || []).includes(tenantID);
}
